import(/* webpackMode: "eager" */ "/home/runner/work/techxeed-frontend/techxeed-frontend/src/app/signup/(forms)/page.tsx");
